
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 13.2C11.7674 13.2 13.2 11.7673 13.2 9.99999C13.2 8.23268 11.7674 6.79999 10 6.79999C8.23274 6.79999 6.80005 8.23268 6.80005 9.99999C6.80005 11.7673 8.23274 13.2 10 13.2Z","fill":"#000","fill-opacity":"0.4"}}),_c('path',{attrs:{"d":"M7 0L5.17 2H2C0.9 2 0 2.9 0 4V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V4C20 2.9 19.1 2 18 2H14.83L13 0H7ZM10 15C7.24 15 5 12.76 5 10C5 7.24 7.24 5 10 5C12.76 5 15 7.24 15 10C15 12.76 12.76 15 10 15Z","fill":"#000","fill-opacity":"0.4"}})])
          )
        }
      }
    